import React, { memo } from 'react';
import { Card, Button, Typography, Space, Badge, Tooltip } from 'antd';
import { ShoppingCartOutlined, InboxOutlined } from '@ant-design/icons';
import { formatCurrency } from '../../utils/currency';
import CategoryTag from '../../components/CategoryTag';

const { Text, Title } = Typography;

const ProductGridCard = memo(({ product, onAdd }) => {
    // For USED products, stock is injected from purchase_items (status='ready' count)
    // For normal products, stock comes from Dolibarr
    const isOutOfStock = product.stock <= 0 && product.type === 0;

    return (
        <Card
            hoverable={!isOutOfStock}
            bodyStyle={{ padding: '16px' }}
            onClick={() => !isOutOfStock && onAdd(product)}
            style={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                cursor: isOutOfStock ? 'not-allowed' : 'pointer',
                opacity: isOutOfStock ? 0.7 : 1,
                borderRadius: '8px',
                border: `1px solid ${product.is_used ? '#722ed1' : '#f0f0f0'}`
            }}
        >
            <div style={{ flex: 1, marginBottom: '12px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '4px' }}>
                    <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
                        <CategoryTag category_id={product.category_id} />
                        {product.is_used && (
                            <Badge count="Used" style={{ backgroundColor: '#722ed1', fontSize: '10px' }} />
                        )}
                    </div>
                    {product.type === 1 ? (
                        <Badge status="processing" text="Service" />
                    ) : (
                        <Badge
                            count={product.stock > 0 ? `In: ${product.stock}` : 'Out of Stock'}
                            color={product.stock > 0 ? '#1890ff' : '#f5222d'}
                            style={{ fontSize: '10px' }}
                        />
                    )}
                </div>


                <Title level={5} style={{ margin: '8px 0 2px 0', fontSize: '15px' }} ellipsis={{ rows: 2 }}>
                    {product.label}
                </Title>
                <Text type="secondary" style={{ fontSize: '12px', display: 'block' }} ellipsis>
                    {product.ref}
                </Text>
            </div>

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 'auto' }}>
                <Title level={4} style={{ margin: 0, color: '#52c41a', fontSize: '17px' }}>
                    {formatCurrency(product.price)}
                </Title>
                <Tooltip title={isOutOfStock ? 'Out of Stock' : 'Add to Cart'}>
                    <Button
                        type="primary"
                        shape="circle"
                        icon={<ShoppingCartOutlined />}
                        disabled={isOutOfStock}
                        onClick={(e) => {
                            e.stopPropagation();
                            onAdd(product);
                        }}
                    />
                </Tooltip>
            </div>
        </Card>
    );
});

ProductGridCard.displayName = 'ProductGridCard';

export default ProductGridCard;
